import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatMoney } from "utilities/datalist/datalist-sort-utilities";
import HTMLCode from "../HTMLCode";

type MoneyViewPropsType = {
    value?: number | string;
    extension?: IconDefinition;
}

const MoneyView = (props: MoneyViewPropsType) => {
    const getExtension = () => {
        if (props.extension) {
            return <FontAwesomeIcon icon={props.extension} />;
        }
        return <HTMLCode code="euro" />;   
    }

    return (
        <>{formatMoney(props.value)} {getExtension()}</>
    );
};

export default MoneyView;
